.check {
	display: inline-flex;
	align-items: center;
	gap: var(--space-3);
	min-width: 0;
	cursor: pointer;
}

.check:has(input:disabled) {
	cursor: not-allowed;
}

.control {
	position: relative;
	flex: none;
	display: inline-flex;
	width: 22px;
	height: 22px;
}

.control input {
	position: absolute;
	inset: 0;
	margin: 0;
	opacity: 0;
	cursor: inherit;
}

.box {
	width: 22px;
	height: 22px;
	border: 1.5px solid var(--border);
	border-radius: 6px;
	background: var(--surface-input);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	transition:
		background-color 120ms ease,
		border-color 120ms ease;
}

.control input:checked + .box {
	background: var(--accent-sage);
	border-color: var(--accent-sage);
}

.control input:checked + .box::after {
	content: '';
	width: 6px;
	height: 11px;
	border: solid #fff;
	border-width: 0 2px 2px 0;
	transform: rotate(45deg) translate(-1px, -1px);
}

.control input:disabled + .box {
	opacity: 0.5;
}

.control input:focus-visible + .box {
	outline: 2px solid var(--accent-sage);
	outline-offset: 2px;
}
